export function calculateDiscountPercentage(oldPrice: number, price: number) {
  if (oldPrice <= 0 || price < 0) {
    return 0;
  }

  const discountPercent = Math.floor(((oldPrice - price) / oldPrice) * 100);
  return discountPercent;
}
